import { render } from "@insightfulscience/smart-react/Modals/Engine";
import pipe from "@insightfulscience/shared-utils/fn/pipe";
// import { WithLocale } from "@insightfulscience/smart-react/i18";
import OpenInSnapgeneModal from "."; // TODO: brake the cycle imports
// import resources from "../../locales";

const openInApp = (plasmidName, filePath) => {
	return render(pipe(OpenInSnapgeneModal), { plasmidName, filePath });
};
export default openInApp;
